<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn flat icon color="primary" @click.stop="dialog = true" v-on="on">
          <v-icon color="primary" dark>add_circle</v-icon>
        </v-btn>
      </template>
      <span>Add a new house</span>
    </v-tooltip>

    <v-dialog v-model="dialog" max-width="600" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>Add House</v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container grid-list-md>
              <v-layout row>
                <v-flex xs12 sm2>
                  <v-text-field v-model="unit" label="Unit" light></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field v-model="number" label="Number" required light></v-text-field>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-text-field v-model="street" label="Street" required :rules="textRules"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 sm4>
                  <v-text-field v-model="suburb" label="Suburb" required flat :rules="textRules"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field v-model="city" label="City" required :rules="textRules"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field v-model="country" label="Country" required :rules="textRules"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn flat @click="close()">Cancel</v-btn>

          <v-btn color="primary" @click="save()">
            <v-icon>add</v-icon>Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import alertHelper from '@/helpers/alert'

export default {
  name: 'Add',
  data() {
    return {
      dialog: false,
      valid: false,
      unit: '',
      number: '',
      street: '',
      suburb: '',
      city: 'Christchurch',
      country: 'New Zealand',
      textRules: [(v) => !!v || 'This field is required'],
      digitRules: [
        (v) => !!v || 'Number is required',
        (v) => /^\d+$/.test(v) || 'Number must be valid',
      ],
    }
  },
  methods: {
    ...mapActions({
      addHouse: 'HouseList/addHouse',
    }),
    save: function () {
      this.$refs.form.validate()

      if (this.valid) {
        this.addHouse({
          unit: this.unit,
          num: this.number,
          street: this.street,
          suburb: this.suburb,
          city: this.city,
          country: this.country,
        })
        this.dialog = false
        this.$refs.form.reset()
      } else {
        alertHelper.error('Please fill in all the required fields')
      }
    },
    close: function () {
      this.unit = ''
      this.number = ''
      this.street = ''
      this.suburb = ''
      this.city = ''
      this.country = ''
      this.dialog = false
    },
  },
}
</script>
